/**
 * @whatItDoes Returns early started bootloader promise saved on window (i.e to ensure client configs are loaded).
 *
 * @howToUse
 *
 * main.ts
 * ```
 platformBrowserDynamic([bootloaderProvider()]).bootstrapModule(AppModule).catch(err => console.error(err));
 * ```
 *
 * @stable
 */
import { provideAppInitializer } from '@angular/core';

export function bootloader(): Promise<void> {
    return (window as any)['_boot'];
}

export const bootloaderProvider = () => {
    return provideAppInitializer(() => {
        const initializerFn = (window as any)['_boot']();
        return initializerFn();
    });
};
